import { useCallback, useState } from "react"
import type { LineManagerAssignment, NewLineManagerAssignment } from "../../organisms/AssignLineManagerDeputy/AssignLineManagerDeputy.static"

export const useTemporaryLineManagerPage = () => {
  const [activeTab, setActiveTab] = useState(0)
  // TODO: wire backend active-assignment query.
  const [assignments, setAssignments] = useState<readonly LineManagerAssignment[]>([])

  const addAssignment = useCallback((assignment: NewLineManagerAssignment) => {
    // TODO: wire backend line_manager.assign mutation and refresh the assignment list.
    setAssignments(currentAssignments => [
      ...currentAssignments,
      {
        ...assignment,
        id: crypto.randomUUID(),
        submittedAt: new Date().toISOString(),
      },
    ])
    setActiveTab(1)
  }, [])

  const removeAssignment = useCallback((id: string) => {
    // TODO: wire backend line_manager.remove mutation and refresh the assignment list.
    setAssignments(currentAssignments => currentAssignments.filter(assignment => assignment.id !== id))
  }, [])

  return { activeTab, addAssignment, assignments, removeAssignment, setActiveTab }
}
